/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoContribuyente from 'Infotrack@Modelos/administracion/tipoContribuyente/entidades/tipoContribuyente';
import React from 'react';
import TipoContribuyenteCM from '../controladorModelo/tipoContribuyenteCM';
import { acciones, IEstadoTipoContribuyente } from '../reductorTipoContribuyente';
import TipoContribuyenteVista from '../vista/tablaTipoContribuyenteVista';

const tipoContribuyenteCM = new TipoContribuyenteCM();

const TableTipoContribuyenteCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tipoContribuyentes, setTipoContribuyentes] = React.useState<ITipoContribuyente[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTipoContribuyente>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTipoContribuyente();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTipoContribuyente = () => {
        manejadorIndicadorCargaGlobal(true);
        tipoContribuyenteCM.consultarTipoContribuyente().then((tipoContribuyentes) => {
            setTipoContribuyentes(tipoContribuyentes);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTipoContribuyente?: ITipoContribuyente) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTipoContribuyente, tipoFormulario } });
    };

    const confirmarEliminacion = (tipoContribuyente: ITipoContribuyente) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTipoContribuyente(tipoContribuyente),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };
    const eliminarTipoContribuyente = (tipoContribuyente: ITipoContribuyente) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tipoContribuyenteCM.eliminarTipoContribuyente(tipoContribuyente).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TipoContribuyenteVista
            tipoContribuyentes={tipoContribuyentes}
            cargarTipoContribuyente={cargarTipoContribuyente}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTipoContribuyenteCV;
